<template>
    <table style="width:100%;">
        <tr>
            <td style="width:90%;">
                <Select v-if="sc_isValue"
                        v-model="sc_value"
                        :size="sc_size"
                        :multiple="sc_multiple">
                    <Option v-for="item in sc_optionList" :value="item.value" :key="item.key">{{ item.key }}</Option>
                </Select>
                <Select v-else
                        v-model="sc_value"
                        :size="sc_size"
                        :multiple="sc_multiple">
                    <Option v-for="item in sc_optionList" :value="item.key" :key="item.key">{{ item.key }}</Option>
                </Select>
            </td>
            <td style="width:10%;">
                <Button type="dashed" title="操作种类" style="margin-left:10px;" @click="sc_modalDisPlay=true;">
                    <Icon type="ios-settings-outline" size='18'/>
                </Button>
                <Modal v-model="sc_modalDisPlay" draggable sticky scrollable>
                    <p slot="header" style="text-align:left">
                        <Icon type="ios-create-outline" size='18'/>
                        <span> 添加种类</span>
                    </p>
                    <div style="width:100%;padding:5px;background-color:#fff;border-radius:5px;height:300px;overflow:auto;">
                        
                        <table style="width:100%;">
                            <tr>
                                <td style="width:50%;">
                                    <Input v-model="sc_formItem.key" placeholder="请输入显示名" />
                                </td>
                                <td style="width:50%;" colspan="2">
                                    <Input v-model="sc_formItem.value" placeholder="请输入编号" @keyup.enter.native="sc_addDictionary()"/>
                                </td>
                            </tr>
                            <tr>
                                <td class="tab-hander">显示名</td>
                                <td class="tab-hander">编号</td>
                                <td class="tab-hander" style="text-align:center;">操作</td>
                            </tr>
                            <tr v-for="item in sc_optionList">
                                <td>{{item.key}}</td>
                                <td>{{item.value}}</td>
                                <td style="text-align:center;">
									<Icon type="md-trash" size='20' class="deleOption" @click.stop="sc_deleOption(item.id)"/>
                                </td>
                            </tr>
                        </table>
                        
                    </div>
                    <div slot="footer">
                        <Button size="large" type="error" @click="sc_cancel()">关闭</Button>
                        <Button size="large" @click="sc_addDictionary()">保存</Button>
                    </div>
                </Modal>
            </td>
        </tr>
    </table>
</template>

<script>
    import request from '@/utils/request'

    export default {
        name: 'SelectConfig',
        props: ['sc_data', 'sc_type','sc_multiple','sc_isValue','sc_size'],
        data() {
            return {
                sc_optionList: [],
                sc_value: [],
                sc_modalDisPlay: false,
                sc_formItem: {
                    id:0,
                    key: '',
                    value: '',
                    pid:0,
					pcode:'',
                    creator: parseInt(localStorage.getItem("userId"))
                }
            }
        },

        methods: {
            sc_initOptionList() {
                let component = this;
                //获取供应商品类数据字典
                request.get('/api/DataDictionary/GetDataDictionaryList', {
                    params: {
                        code: this.sc_type
                    }
                }).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',
                            duration: 3,
                            desc: "获取字典数据失败：" + response.errorMsg
                        });
                        return;
                    }

                    component.sc_optionList = response.data;
                }).catch(function (error) {
                })
            },
            sc_addDictionary() {
                if (!this.sc_formItem.key) {
                    this.$Notice.error({
                        title: '错误提示',
                        duration: 3,
                        desc: '显示名不可为空!'
                    });
                    return;
                }

                if (this.sc_formItem.key.length > 20) {
                    this.$Notice.error({
                        title: '错误提示',
                        duration: 3,
                        desc: '“显示名”输入内容不得大于20个字!'
                    });
                    return;
                }

                if (!this.sc_formItem.value) {
                    this.$Notice.error({
                        title: '错误提示',
                        duration: 3,
                        desc: '编号不可为空!'
                    });
                    return;
                }

                if (this.sc_formItem.value.length > 20) {
                    this.$Notice.error({
                        title: '错误提示',
                        duration: 3,
                        desc: '“编号”输入内容不得大于20个字!'
                    });
                    return;
                }
                this.sc_formItem.pcode = this.sc_type;
                let component = this;
                request.post('/api/DataDictionary/AddDataDictionary', this.sc_formItem).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',
                            duration: 3,
                            desc: '保存失败:' + response.errorMsg
                        });
                        return;
                    }

                    component.sc_initOptionList();
                    component.sc_formItem.key = '';
                    component.sc_formItem.value = '';
                    component.$Notice.success({
                        title: '正确提示',
                        duration: 3,
                        desc: '保存成功!'
                    });

                }).catch(function (error) {
                })
            },
            getValue() {
                if (this.sc_multiple && typeof (this.sc_value) == "object") {
                    return this.sc_value.join(',');
                } else {
					if(this.sc_value){
						return this.sc_value+'';
					}
                    return '';
                }
                
            },
            sc_deleOption(id) {
                var component = this;
                request.post('/api/DataDictionary/DeleDataDictionary', [id]).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',
                            duration: 3,
                            desc: response.errorMsg
                        });
                        return;
                    }
                    component.sc_initOptionList();
                    component.$Notice.success({
                        title: '正确提示',
                        duration: 3,
                        desc: '删除成功!'
                    });
                }).catch(function (error) {
                })
            },
            sc_cancel() {
                this.sc_modalDisPlay = false;
            },
        },
        watch: {
            sc_data(val) {
                if (val.indexOf(',') > -1) {
                    this.sc_value = val.split(',');
                } else {
                    this.sc_value = val;
                }
            }
        },
        created: function () {
            this.sc_initOptionList();
        }
    }
</script>

<style scoped>
    .ivu-select-multiple .ivu-select-item-selected:after {
        content: '' !important;
    }
	.deleOption{
		cursor: pointer;
	}
	
    .deleOption:hover {
        transform: scale(1.1);
    }

    .deleOption:focus {
        box-shadow: 0px 0px 1px 1px #808080;
    }
    .tab-hander {
        background: #f7f7f7;
        color: #5c6b77;
        font-weight:600;
        font-size:15px;
    }
</style>
